<script setup lang="ts">
import { ref,reactive,onMounted,onBeforeUnmount,toRefs,watch } from 'vue'
import CustomList from "../../../../compositions/CustomList.vue";
import ModalDialog from "../../../../compositions/ModalDialog.vue";
import SearchBox from "../../../../compositions/SearchBox.vue";
import SelectBox from "../../../../compositions/SelectBox.vue";
import Chart from "../../../../compositions/Chart.vue";
import SummaryMedicineComponent from '../../../Common/SummaryMedicineComponent.vue';
import config from "../../../../config.js";
import { errorAlert } from "../../../../plugins/alert";
import { getFieldValue } from "../../../../plugins/utility";
import qs from 'qs';
import axios from '../../../../plugins/axios.ts';
import { deepCopy } from "../../../../plugins/utility";
import HelpAction from '../../../../compositions/HelpAction.vue';


const props = defineProps({
    apis:{
      type:Object,
      required:true,
    },
    identityId: {
      typ:Number,
      default:() => {
        return 0;
      }
    },
    searchParams: {
      typ:Object,
      default:() => {
        return {};
      }
    },
    isVisible:{
        type:Boolean,
        default: () => {
            return false;
        }
    }
})

const { isVisible,identityId,searchParams } = toRefs(props);
const listRef = ref();
const searchParamsData = reactive(props.searchParams);
const medicineSummaryFields = reactive([
  {field_name: '薬局名', field_key: 'pharmacy_name', width: '50%', align: 'text-left',sorted:false},
  {field_name: '品目数', field_key: 'drug_price_standard_count', width: '50%', align: 'text-right',sorted:false},
]);
const refreshView = (force=false) => {
  if (isVisible.value == false) {
    return;
  }
  if (typeof listRef.value !== 'undefined') {
    listRef.value.resetItem();
  }
}
watch(isVisible,(newValue, oldValue) => {
  if (newValue) {
    refreshView();
  }
})
watch(identityId,(newValue, oldValue) => {
  refreshView();
})
watch(searchParams,(newValue, oldValue) => {
  refreshView();
},{deep:true})
onMounted(() => {
  refreshView();
});
</script>

<style scoped>
</style>
<template>
<div v-show="isVisible" class="relative">
  <div class="w-full mt-1">
    <div class="font-bold">【薬価基準収載医薬品品目数一覧】</div>
    <div class="text-sm">※表示されている品目数は、OTC等を除いたメディコード医薬品の品目数となります。<br>また品目数は規格違いや後発品のメーカー違いは同一品目として集計しております。</div>
    <custom-list
      ref="listRef"
      :api-url="apis.summary_drug_price_standard_list"
      :table-fields="medicineSummaryFields"
      :option-fields="searchParamsData"
      :is-downloadable="true"
      font-size="0.8em"
      height="68vh"
    >
    <template v-slot:item="slotProps">
      <summary-medicine-component
        :apis="apis"
        :item="slotProps.item"
        :fields="medicineSummaryFields"
      ></summary-medicine-component>
    </template>
    </custom-list>
  </div>
</div>
</template>
